const API_BASE = process.env.REACT_APP_API_BASE_URL || '/eamgw-idp-admin/v1';

/* Login */
export const AUTHENTICATE = `${API_BASE}/authenticate`;
export const LOGOUT = `${API_BASE}/logout`;

/* Standard Based Application */
export const CREATE_OIDC_CLIENT_CREDENTIALS = `${API_BASE}/sba-app/oidc/client-credentials/create`;
export const CREATE_SBA_APP = `${API_BASE}/sba-app/create`;
